let quantityValue = 1;

function handleQuantitySelector() {
  const dataControl = this.dataset.controlButton;
  const originalQuantitySelector = document.querySelector('.quantity-actual');
  const plusControl = document.querySelector('[data-control-button="plus"]');
  const minusControl = document.querySelector('[data-control-button="minus"]');
  dataControl === 'minus' && quantityValue > 1 ? quantityValue-- : dataControl === 'plus' && quantityValue < 10 ? quantityValue++ : null;
  quantityValue >= 10 ? plusControl.classList.add('quantity-picker__control--disabled') : plusControl.classList.remove('quantity-picker__control--disabled');
  quantityValue === 1 ? minusControl.classList.add('quantity-picker__control--disabled') : minusControl.classList.remove('quantity-picker__control--disabled');
  originalQuantitySelector.value = quantityValue;
  renderYardQuantity(quantityValue);
}

function renderYardQuantity(quantity) {
  const quantityDifference = quantity / 2;
  const isCompleteYard = Number.isInteger(quantityDifference);
  const halfYard = '1/2';
  const quantityRenderSelector = document.querySelector('[data-quantity-selector]');
  quantityRenderSelector.value = isCompleteYard ? quantityDifference : `${quantity === 1 ? `${halfYard}` : `${parseInt(quantityDifference)} ${halfYard}`}`;
}

const quantityPickers = document.querySelectorAll('.quantity-picker__control');
if(quantityPickers) {
  quantityPickers.forEach(element => element.addEventListener('click', handleQuantitySelector));
}